module.exports = {"server":{"local":"http://cognitiongraphql.insightacademy.co.za","test":"https://cognition.dev.stackworx.cloud","prod":"https://graphql.cognition.online"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 1437
// module chunks = 0